/**
 * Shared Leaflet locations map + hero-split search.
 * No Google Maps — OSM tiles + stored lat/lng only.
 */
(function ($, window) {
	'use strict';

	var statusColors = {
		open: '#4F46E5',
		in_development: '#D97706',
		coming_soon: '#059669'
	};

	var clientCache = {};
	var CACHE_PREFIX = 'dfd_loc_search_v2_';
	var LIST_LIMIT = 40;

	function escapeHtml(str) {
		return String(str || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	function i18n(key, fallback) {
		var cfg = window.dfdLocationsMap || {};
		return (cfg.i18n && cfg.i18n[key]) || fallback;
	}

	function placeLine(loc) {
		var city = loc.city || '';
		var state = loc.state || '';
		var zip = loc.zip || '';
		var line = city + (city && state ? ', ' : '') + state;
		if (zip) {
			line = line ? line + ' ' + zip : zip;
		}
		return line;
	}

	function statusLabel(loc) {
		return loc.status_label || loc.status || '';
	}

	function locationUrl(loc) {
		return loc.url || loc.franchise_url || '';
	}

	function buildPopupHtml(loc) {
		var url = locationUrl(loc);
		var place = placeLine(loc);
		var status = statusLabel(loc);
		var brand = loc.franchise_title || '';
		var model = loc.model_label || '';
		var titleHtml = url
			? '<a class="franchise-map-popup-title" href="' + escapeHtml(url) + '">' + escapeHtml(loc.title) + '</a>'
			: '<strong>' + escapeHtml(loc.title) + '</strong>';

		var meta = [];
		if (brand) {
			meta.push(escapeHtml(brand));
		}
		if (place) {
			meta.push(escapeHtml(place));
		}
		if (status) {
			meta.push(escapeHtml(status));
		}
		if (model) {
			meta.push(escapeHtml(model));
		}

		var html = '<div class="franchise-map-popup">' + titleHtml;
		if (meta.length) {
			html += '<p class="franchise-map-popup-meta">' + meta.join(' · ') + '</p>';
		}
		if (url) {
			html += '<a class="franchise-map-popup-link" href="' + escapeHtml(url) + '">' +
				escapeHtml(i18n('viewLocation', 'View details')) + '</a>';
		}
		html += '</div>';
		return html;
	}

	function parseLocations(el) {
		var raw = el.getAttribute('data-locations');
		if (!raw) {
			return [];
		}
		try {
			return JSON.parse(raw);
		} catch (e) {
			return [];
		}
	}

	function clearMarkers(el) {
		if (!el._franchiseMarkers) {
			return;
		}
		el._franchiseMarkers.forEach(function (marker) {
			if (el._franchiseMap) {
				el._franchiseMap.removeLayer(marker);
			}
		});
		el._franchiseMarkers = [];
		el._franchiseMarkerById = {};
		el._franchiseBounds = [];
	}

	function addMarkers(el, locations) {
		var map = el._franchiseMap;
		var bounds = [];
		var markers = [];
		var byId = {};

		if (!map) {
			return;
		}

		(locations || []).forEach(function (loc) {
			if (typeof loc.lat !== 'number' || typeof loc.lng !== 'number') {
				return;
			}
			var color = statusColors[loc.status] || statusColors.open;
			var marker = L.circleMarker([loc.lat, loc.lng], {
				radius: 7,
				color: '#fff',
				weight: 2,
				fillColor: color,
				fillOpacity: 0.95
			}).addTo(map);

			marker.bindPopup(buildPopupHtml(loc), { maxWidth: 280 });
			marker._dfdLocation = loc;

			if (locationUrl(loc)) {
				marker.on('dblclick', function () {
					window.location.href = locationUrl(loc);
				});
			}

			if (loc.id) {
				byId[String(loc.id)] = marker;
			}

			bounds.push([loc.lat, loc.lng]);
			markers.push(marker);
		});

		el._franchiseMarkers = markers;
		el._franchiseMarkerById = byId;
		el._franchiseBounds = bounds;

		if (bounds.length) {
			map.fitBounds(bounds, { padding: [28, 28], maxZoom: 6 });
		} else {
			map.setView([39.5, -98.35], 4);
		}
	}

	function focusLocation(mapEl, locationId) {
		if (!mapEl || !mapEl._franchiseMap || !mapEl._franchiseMarkerById) {
			return;
		}
		var marker = mapEl._franchiseMarkerById[String(locationId)];
		if (!marker) {
			return;
		}
		var latLng = marker.getLatLng();
		mapEl._franchiseMap.setView(latLng, Math.max(mapEl._franchiseMap.getZoom(), 8), {
			animate: true
		});
		marker.openPopup();
	}

	function initMap(el) {
		if (typeof L === 'undefined' || el._franchiseMap) {
			return el._franchiseMap || null;
		}

		var locations = parseLocations(el);
		var map = L.map(el, {
			scrollWheelZoom: false,
			attributionControl: true
		});

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 18,
			attribution: '&copy; OpenStreetMap'
		}).addTo(map);

		el._franchiseMap = map;
		el._franchiseMarkers = [];
		el._franchiseMarkerById = {};
		el._franchiseBounds = [];
		addMarkers(el, locations);

		setTimeout(function () {
			map.invalidateSize();
		}, 50);

		return map;
	}

	function setLocations(el, locations) {
		if (!el._franchiseMap) {
			el.setAttribute('data-locations', JSON.stringify(locations || []));
			initMap(el);
			return;
		}
		clearMarkers(el);
		el.setAttribute('data-locations', JSON.stringify(locations || []));
		addMarkers(el, locations);
		el._franchiseMap.invalidateSize();
	}

	function invalidate(el) {
		if (el && el._franchiseMap) {
			el._franchiseMap.invalidateSize();
		}
	}

	function cacheGet(query) {
		var key = CACHE_PREFIX + query;
		if (clientCache[key]) {
			return clientCache[key];
		}
		try {
			var raw = window.sessionStorage.getItem(key);
			if (raw) {
				var parsed = JSON.parse(raw);
				clientCache[key] = parsed;
				return parsed;
			}
		} catch (e) {
			// sessionStorage unavailable
		}
		return null;
	}

	function cacheSet(query, data) {
		var key = CACHE_PREFIX + query;
		clientCache[key] = data;
		try {
			window.sessionStorage.setItem(key, JSON.stringify(data));
		} catch (e) {
			// quota / private mode
		}
	}

	function normalizeQuery(query) {
		var value = String(query || '');
		var textarea = document.createElement('textarea');
		textarea.innerHTML = value;
		value = textarea.value;
		value = value
			.replace(/[\u2013\u2014\u2212\u2010\u2011]/g, '-')
			.replace(/[\u201C\u201D\u201E]/g, '"')
			.replace(/[\u2018\u2019\u201A]/g, "'")
			.replace(/[\u2026\u00B7]/g, ' ')
			.replace(/[^a-zA-Z0-9\s\-]+/g, ' ')
			.replace(/\s+/g, ' ')
			.trim()
			.toLowerCase();
		return value;
	}

	function searchLocations(query) {
		var normalized = normalizeQuery(query);
		var cfg = window.dfdLocationsMap || {};
		var deferred = $.Deferred();

		if (!normalized) {
			deferred.reject({ message: i18n('noResults', 'No results') });
			return deferred.promise();
		}

		var cached = cacheGet(normalized);
		if (cached) {
			deferred.resolve($.extend({}, cached, { cached: true, clientCached: true }));
			return deferred.promise();
		}

		$.ajax({
			url: cfg.ajaxUrl || '/wp-admin/admin-ajax.php',
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'dfd_search_locations',
				nonce: cfg.nonce || '',
				q: query
			}
		})
			.done(function (res) {
				if (!res || !res.success || !res.data) {
					deferred.reject(res && res.data ? res.data : {});
					return;
				}
				cacheSet(normalized, res.data);
				deferred.resolve(res.data);
			})
			.fail(function () {
				deferred.reject({
					message: i18n('error', 'Error')
				});
			});

		return deferred.promise();
	}

	function renderHeroResults($block, data) {
		var $panel = $block.find('[data-hero-split-results]');
		var $list = $block.find('[data-hero-split-results-list]');
		var $title = $block.find('[data-hero-split-results-title]');
		var $note = $block.find('[data-hero-split-results-note]');
		var mapEl = $block.find('[data-franchise-map]').get(0);
		var locations = (data && data.locations) || [];
		var franchises = (data && data.franchises) || [];
		var html = '';
		var shown;

		if (!$panel.length || !$list.length) {
			return;
		}

		if (!locations.length && !franchises.length) {
			$panel.attr('hidden', true);
			$list.empty();
			if ($note.length) {
				$note.text('');
			}
			return;
		}

		if (franchises.length) {
			html += '<li class="hero-split-results-group">' +
				escapeHtml(i18n('brandsHeading', 'Matching franchises')) + '</li>';
			franchises.forEach(function (brand) {
				if (!brand || !brand.url) {
					return;
				}
				html += '<li class="hero-split-result hero-split-result--brand">' +
					'<a class="hero-split-result-link" href="' + escapeHtml(brand.url) + '">' +
					'<span class="hero-split-result-title">' + escapeHtml(brand.title) + '</span>' +
					'<span class="hero-split-result-meta">' +
					escapeHtml(i18n('viewBrand', 'View franchise')) +
					'</span></a></li>';
			});
		}

		if (locations.length) {
			html += '<li class="hero-split-results-group">' +
				escapeHtml(i18n('resultsHeading', 'Matching locations')) + '</li>';
			shown = locations.slice(0, LIST_LIMIT);
			shown.forEach(function (loc) {
				var url = locationUrl(loc);
				var place = placeLine(loc);
				var metaBits = [];
				if (loc.franchise_title) {
					metaBits.push(escapeHtml(loc.franchise_title));
				}
				if (place) {
					metaBits.push(escapeHtml(place));
				}
				if (statusLabel(loc)) {
					metaBits.push(escapeHtml(statusLabel(loc)));
				}
				if (loc.model_label) {
					metaBits.push(escapeHtml(loc.model_label));
				}

				html += '<li class="hero-split-result" data-location-id="' + escapeHtml(loc.id) + '">';
				if (url) {
					html += '<a class="hero-split-result-link" href="' + escapeHtml(url) + '">';
				} else {
					html += '<div class="hero-split-result-link">';
				}
				html += '<span class="hero-split-result-title">' + escapeHtml(loc.title) + '</span>';
				if (metaBits.length) {
					html += '<span class="hero-split-result-meta">' + metaBits.join(' · ') + '</span>';
				}
				html += url ? '</a>' : '</div>';

				if (typeof loc.lat === 'number' && typeof loc.lng === 'number') {
					html += '<button type="button" class="hero-split-result-map" data-focus-location="' +
						escapeHtml(loc.id) + '">' +
						escapeHtml(i18n('showOnMap', 'Show on map')) + '</button>';
				}
				html += '</li>';
			});
		}

		$list.html(html);
		$panel.removeAttr('hidden');

		if ($title.length) {
			$title.text(i18n('resultsHeading', 'Matching locations'));
		}

		if ($note.length) {
			if (locations.length > LIST_LIMIT) {
				$note.text(
					i18n('showingOf', 'Showing %1$s of %2$s')
						.replace('%1$s', String(LIST_LIMIT))
						.replace('%2$s', String(locations.length))
				);
			} else {
				$note.text('');
			}
		}

		$list.off('click.dfdFocus').on('click.dfdFocus', '[data-focus-location]', function (e) {
			e.preventDefault();
			e.stopPropagation();
			focusLocation(mapEl, $(this).attr('data-focus-location'));
			var media = $block.find('[data-hero-split-media]').get(0);
			if (media && media.scrollIntoView) {
				media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		});
	}

	function showHeroMap($block, data) {
		var $media = $block.find('[data-hero-split-media]');
		var $image = $block.find('[data-hero-split-image]');
		var $mapPanel = $block.find('[data-hero-split-map]');
		var $status = $block.find('[data-hero-split-map-status]');
		var mapEl = $mapPanel.find('[data-franchise-map]').get(0);
		var count = data && data.count ? data.count : 0;

		$media.addClass('is-showing-map');
		$image.attr('aria-hidden', 'true');
		$mapPanel.removeAttr('hidden').attr('aria-hidden', 'false');

		// Retrigger fade-up.
		$mapPanel.removeClass('is-visible');
		// Force reflow.
		void $mapPanel[0].offsetWidth;
		$mapPanel.addClass('is-visible');

		if (mapEl) {
			setLocations(mapEl, (data && data.locations) || []);
			setTimeout(function () {
				invalidate(mapEl);
			}, 320);
		}

		if ($status.length) {
			if (count) {
				$status.text(count + ' ' + i18n('resultLabel', 'locations found'));
				$status.removeClass('is-empty');
			} else {
				$status.text(i18n('noResults', 'No locations matched that search.'));
				$status.addClass('is-empty');
			}
		}

		renderHeroResults($block, data || { locations: [], franchises: [] });
	}

	function setHeroSearching($block, isSearching) {
		var $btn = $block.find('[data-hero-split-search] [type="submit"]');
		var $status = $block.find('[data-hero-split-map-status]');

		$block.toggleClass('is-searching', !!isSearching);
		$btn.prop('disabled', !!isSearching);

		if (isSearching && $status.length) {
			$status.text(i18n('searching', 'Searching…')).removeClass('is-empty');
		}
	}

	function bindHeroSplitSearch() {
		$('.hero-split-block, .hero-home-block').each(function () {
			var $block = $(this);
			if ($block.data('dfdMapBound')) {
				return;
			}
			$block.data('dfdMapBound', true);

			$block.on('submit', '[data-hero-split-search]', function (e) {
				var $form = $(this);
				var query = String($form.find('input[type="search"]').val() || '').trim();
				var $mapPanel = $block.find('[data-hero-split-map]');

				if (!$mapPanel.length || !query) {
					return;
				}

				e.preventDefault();
				setHeroSearching($block, true);

				// Reveal panel early so the fade-up feels immediate.
				$block.find('[data-hero-split-media]').addClass('is-showing-map');
				$block.find('[data-hero-split-image]').attr('aria-hidden', 'true');
				$mapPanel.removeAttr('hidden').attr('aria-hidden', 'false');
				$mapPanel.removeClass('is-visible');
				void $mapPanel[0].offsetWidth;
				$mapPanel.addClass('is-visible is-loading');

				searchLocations(query)
					.done(function (data) {
						$mapPanel.removeClass('is-loading');
						showHeroMap($block, data);
					})
					.fail(function (err) {
						$mapPanel.removeClass('is-loading');
						showHeroMap($block, { count: 0, locations: [], franchises: [] });
						$block.find('[data-hero-split-map-status]')
							.text((err && err.message) || i18n('error', 'Error'))
							.addClass('is-empty');
					})
					.always(function () {
						setHeroSearching($block, false);
					});
			});
		});
	}

	window.DFDLocationsMap = {
		statusColors: statusColors,
		parseLocations: parseLocations,
		initMap: initMap,
		setLocations: setLocations,
		invalidate: invalidate,
		searchLocations: searchLocations,
		focusLocation: focusLocation,
		escapeHtml: escapeHtml
	};

	$(function () {
		bindHeroSplitSearch();
		$('[data-franchise-map]').each(function () {
			if ($(this).closest('[hidden]').length) {
				return;
			}
			initMap(this);
		});
	});
})(jQuery, window);
